"use client";

import type { ReactElement } from "react";

interface TextDividerProps {
  spacing?: ReactElement<unknown> | string;
  text: ReactElement<unknown> | string;
  textSize?: ReactElement<unknown> | string;
  maskColor?: string;
}

export const TextDivider = ({
  text,
  spacing = "my-2",
  textSize = "text-[10px]",
  maskColor = "bg-background",
}: TextDividerProps) => {
  return (
    <div
      className={`
        relative
        ${spacing}
        w-full
      `}
    >
      <div className="absolute inset-0 flex items-center">
        <span className="w-full border-t border-border-light"></span>
      </div>
      <div
        className={`
          relative flex justify-center
          ${textSize}
          tracking-[1px] uppercase
        `}
      >
        <span
          className={`
            ${maskColor}
            px-4 text-muted
          `}
        >
          {text}
        </span>
      </div>
    </div>
  );
};
